import { localStorage } from '@change-corgi/core/storage';

import type { PendingSignature } from 'src/app/shared/hooks/signature';

type ConsentInput = {
	consentGiven: boolean;
	name: string;
	text: string;
};

// TODO: extract this and src/app/pages/petition/details/hooks/signPetition/localStoredPendingSignature/index.ts to
// a shared hook folder to co-locate typings, etc
export function getConsentInputFromPendingSigInLocalStorage(petitionId: string): ConsentInput | undefined {
	// TODO use usePendingSignature() shared hook
	const pendingSignatureString = localStorage.getItem(`pending-signature-${petitionId}`);

	if (!pendingSignatureString) return undefined;

	try {
		// TODO maybe add some checks after parsing?

		const pendingSignature = JSON.parse(pendingSignatureString) as PendingSignature;

		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		if (pendingSignature?.formData?.marketing_comms_consent) {
			return {
				consentGiven: pendingSignature.formData.marketing_comms_consent,
				name: pendingSignature.formData.consent_name,
				text: pendingSignature.formData.consent_text,
			};
		}
	} catch (e) {
		return undefined;
	}

	return undefined;
}
